import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";
import graphqlClient from "@/GQLClient";
import {
  type ResourceInput,
  SaveResourceDocument,
} from "@/graphql/generated-types";

const save = async (resource: ResourceInput) => {
  const response = await graphqlClient.mutate({
    mutation: SaveResourceDocument,
    variables: {
      resource,
    },
  });

  if (response.data?.resource?.save?.success) {
    return response.data.resource.save.id;
  }

  throw new SentryGraphQLError("resource.save");
};

export default {
  save,
};
